<button *ngIf="shouldEnableAcknowledgement()" (click)="ackowledgementClicked()" class="btn btn-primary btn-dashboard margin-top-20">
  <span *ngIf="question.isImmediateRetakeAvailable()">Acknowledge Explanation and Attempt Again</span>
  <span *ngIf="!question.isImmediateRetakeAvailable()">Acknowledge Explanation</span>
</button>
